import { Link } from 'react-router-dom';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import './styles.css';

const ARTIST_HELP_SECTIONS = [
  { titleKey: 'sections.profile', to: '/profile/artist-help/profile' },
  { titleKey: 'sections.artworks', to: '/profile/artist-help/artworks' },
  { titleKey: 'sections.purchase_originals', to: '/profile/artist-help/purchase-originals' },
  { titleKey: 'sections.limited_editions', to: '/profile/artist-help/limited-editions' },
  { titleKey: 'sections.suarte_features', to: '/profile/artist-help/suarte-features' },
  { titleKey: 'sections.support_subscriptions', to: '/profile/artist-help/support-subscriptions' },
  { titleKey: 'sections.subscriptions_studio', to: '/profile/artist-help/subscriptions-studio' },
  { titleKey: 'sections.payment_commissions', to: '/profile/artist-help/payment-commissions' },
];

export default function ProfileArtistHelp() {
  const t = useTranslations('artist_help.index');

  return (
    <section className="artist-help-profile">
      <header className="artist-help-profile__header">
        <GoBackButton alternativeRoute="/profile" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-profile__sections">
        {ARTIST_HELP_SECTIONS.map((section) => {
          if (section.to) {
            return (
              <Link key={section.titleKey} to={section.to} className="artist-help-profile__section artist-help-profile__section--link">
                <h2>{t(section.titleKey)}</h2>
              </Link>
            );
          }

          return (
            <article key={section.titleKey} className="artist-help-profile__section">
              <h2>{t(section.titleKey)}</h2>
            </article>
          );
        })}
      </div>
    </section>
  );
}
